import React from "react";
import DetalleCard from "~business/Cards/DetalleCard";
import { useDispatch } from "react-redux";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  setPolizaFileName,
  setCuponeraFileName,
  setCedulaMercosurFileName,
  setTarjetaFileName,
  setIsProcessingPoliza,
  setIsProcessingCuponera,
  setIsProcessingCedulaMercosur,
  setIsProcessingTarjeta,
} from "../actions";
import ItemFileUploaderCard from "~business/Cards/ItemFileUploaderCard";

interface ImpresosCardProps {
  isLoading: boolean;
}

/** Nombre del adjunto que despacha cada uploader. */
type Adjunto = "poliza" | "cuponera" | "cedulaMercosur" | "tarjeta";

const title = "Documentación";

const adjuntos: Record<
  Adjunto,
  (campo: { value: string | null; valid: boolean }) => unknown
> = {
  poliza: setPolizaFileName,
  cuponera: setCuponeraFileName,
  cedulaMercosur: setCedulaMercosurFileName,
  tarjeta: setTarjetaFileName,
};

const ImpresosCard: React.FC<ImpresosCardProps> = ({ isLoading }) => {
  const dispatch = useDispatch();

  const handleAdded = (event: unknown, adjunto: Adjunto) => {
    const action = adjuntos[adjunto];
    const value = `temp/${(event as { target: { value: string } }).target.value}`;
    dispatch(
      action({
        value: value,
        valid: true,
      })
    );
  };

  const handleRemoved = (event: unknown, adjunto: Adjunto) => {
    const action = adjuntos[adjunto];
    dispatch(
      action({
        value: null,
        valid: false,
      })
    );
  };

  const handleProcessingPoliza = (value: boolean) => {
    dispatch(setIsProcessingPoliza(value));
  };

  const handleProcessingCuponera = (value: boolean) => {
    dispatch(setIsProcessingCuponera(value));
  };

  const handleProcessingCedulaMercosur = (value: boolean) => {
    dispatch(setIsProcessingCedulaMercosur(value));
  };

  const handleProcessingTarjeta = (value: boolean) => {
    dispatch(setIsProcessingTarjeta(value));
  };

  if (isLoading)
    return (
      <DetalleCard
        isLoading={isLoading}
        title={title}
        IconHeader={DescriptionIcon}
      />
    );

  return (
    <DetalleCard title={title} IconHeader={VerifiedUserIcon}>
      <>
        <ItemFileUploaderCard
          label={"Póliza (requerido)"}
          onAdded={(event) => handleAdded(event, "poliza")}
          onRemoved={(event) => handleRemoved(event, "poliza")}
          onProcessStart={handleProcessingPoliza}
          acceptImage={false}
          acceptPdf={true}
        />
        <ItemFileUploaderCard
          label={"Tarjeta"}
          onAdded={(event) => handleAdded(event, "tarjeta")}
          onRemoved={(event) => handleRemoved(event, "tarjeta")}
          onProcessStart={handleProcessingTarjeta}
          acceptImage={false}
          acceptPdf={true}
        />
        <ItemFileUploaderCard
          label={"Cédula Mercosur"}
          onAdded={(event) => handleAdded(event, "cedulaMercosur")}
          onRemoved={(event) => handleRemoved(event, "cedulaMercosur")}
          onProcessStart={handleProcessingCedulaMercosur}
          acceptImage={false}
          acceptPdf={true}
        />
        <ItemFileUploaderCard
          label={"Cuponera"}
          onAdded={(event) => handleAdded(event, "cuponera")}
          onRemoved={(event) => handleRemoved(event, "cuponera")}
          onProcessStart={handleProcessingCuponera}
          acceptImage={false}
          acceptPdf={true}
        />
      </>
    </DetalleCard>
  );
};

export default ImpresosCard;
